import React from "react";
import { observer } from "mobx-react";
import { DocumentGenerationParamsUpdateStore } from "../../store";
import { DocumentGenerationParamsUpdateForm } from "./DocumentGenerationParamsUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type DocumentGenerationParamsUpdateProps = {
  documentGenerationParamsUpdateStore: DocumentGenerationParamsUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const DocumentGenerationParamsUpdate: React.FC<DocumentGenerationParamsUpdateProps> =
  observer(
    ({
      documentGenerationParamsUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={documentGenerationParamsUpdateStore.isSaving} />
          <DocumentGenerationParamsUpdateForm
            documentGenerationParamsUpdateStore={
              documentGenerationParamsUpdateStore
            }
            contractEffectiveDateError={
              documentGenerationParamsUpdateStore.errors.contractEffectiveDate
                ?.message
            }
            onContractEffectiveDateChange={(value) => {
              documentGenerationParamsUpdateStore.setContractEffectiveDateValue(
                value
              );
            }}
            contractEffectiveDate={
              documentGenerationParamsUpdateStore.entityValues
                .contractEffectiveDate
            }
            contractEndDateError={
              documentGenerationParamsUpdateStore.errors.contractEndDate
                ?.message
            }
            onContractEndDateChange={(value) => {
              documentGenerationParamsUpdateStore.setContractEndDateValue(
                value
              );
            }}
            contractEndDate={
              documentGenerationParamsUpdateStore.entityValues.contractEndDate
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={documentGenerationParamsUpdateStore.saveDisabled}
            onSave={() =>
              documentGenerationParamsUpdateStore.saveDocumentGenerationParams()
            }
            onCancel={() =>
              documentGenerationParamsUpdateStore.cancelDocumentGenerationParams()
            }
          />
          <ErrorDialog
            open={documentGenerationParamsUpdateStore.errorDialogOpened}
            title={documentGenerationParamsUpdateStore.errorTitle}
            description={documentGenerationParamsUpdateStore.errorDescription}
            onClose={() =>
              documentGenerationParamsUpdateStore.closeErrorDialog()
            }
          />
          <ConfirmCancelDialog
            open={documentGenerationParamsUpdateStore.confirmDialogOpened}
            title={documentGenerationParamsUpdateStore.confirmDialogTitle}
            description={
              documentGenerationParamsUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              documentGenerationParamsUpdateStore.executeConfirmedAction()
            }
            onCancel={() =>
              documentGenerationParamsUpdateStore.closeConfirmDialog()
            }
          />
        </>
      );
    }
  );
